import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
// import { Manager, Target, Popper } from "react-popper";

// @material-ui/core components
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Divider from "@material-ui/core/Divider";
import Grow from "@material-ui/core/Grow";
import Hidden from "@material-ui/core/Hidden";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import {makeStyles} from "@material-ui/core/styles";

// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";

// core components
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import {useHistory, Link as RouterLink} from "react-router-dom";
import {cerrarSession, getCompany, getUser} from "util/common/Common";
import ThemeToggleButton from "components/Button/ThemeToggleButton";
import GridItem from "../Grid/GridItem";
import {Avatar, Box, Typography} from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import {fechaCompleta} from "../../util/utils";

const useStyles2 = makeStyles({
    root: {
        width: "100%",
        minHeight: "34px",
        padding: "0 10px",
        backgroundColor: "#3C4858 !important",
        borderRadius: "8px",
        boxShadow: "0 1px 6px rgba(0,0,0,0.15)",
        color: "#fff",
        gap: "10px",
        // botones de la derecha compactos para no agrandar la barra
        "& button": {
            width: "28px !important",
            height: "28px !important",
            minWidth: "28px !important",
            padding: "0 !important",
            margin: "0 !important",
            color: "#fff"
        },
        "& button svg": {
            fontSize: "18px !important",
            width: "18px",
            height: "18px"
        }
    }
});

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks(props) {
    const {ruta = []} = props;
    var datosUsuario = {
        name: "",
        codigoUsuario: ""
    };
    var empresa = {razonSocial: ""};

    if (getUser()) {
        datosUsuario = getUser();
        empresa = getCompany();
    }

    const {name} = datosUsuario;
    const {razonSocial} = empresa;

    const classes2 = useStyles2();
    const classes = useStyles();
    const {rtlActive} = props;

    const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover, {
        [classes.dropdownItemRTL]: rtlActive,
    });
    const managerClasses = classNames({
        [classes.managerClasses]: true,
    });

    const history = useHistory();
    const [openProfile, setOpenProfile] = React.useState(null);
    const handleClickProfile = (event) => {
        if (openProfile && openProfile.contains(event.target)) {
            setOpenProfile(null);
        } else {
            setOpenProfile(event.currentTarget);
        }
    };
    const handleCloseProfile = () => {
        // navega usando history y cierra el popper con un pequeño delay para evitar interferencias
        try {
            history.push('/admin/user-page');
        } catch (e) {
            console.error('Error navigating to user page', e);
            // fallback a navegación por ubicación completa
            try { window.location.href = '/admin/user-page'; } catch (e2) { /* ignore */ }
        }
        // cerrar el popper un poco después para evitar que el ClickAwayListener coma el evento
        setTimeout(() => setOpenProfile(null), 80);
    };
    const handleCloseSession = () => {
        cerrarSession();
    };

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            className={classes2.root}
        >
            {/* 🔹 Ruta de navegación */}
            <Box display="flex" alignItems="center" sx={{minWidth: 0, flex: 1, overflow: "hidden"}}>
                <Box
                    component="span"
                    onClick={() => history.push("/admin/home")}
                    title="Ir al inicio"
                    sx={{display: "flex", alignItems: "center", cursor: "pointer", opacity: 0.85, "&:hover": {opacity: 1}}}
                >
                    <HomeRoundedIcon sx={{fontSize: 17}}/>
                </Box>
                {ruta.map((nombre, i) => {
                    const ultimo = i === ruta.length - 1;
                    return (
                        <React.Fragment key={i}>
                            <NavigateNextIcon sx={{fontSize: 16, mx: 0.25, opacity: 0.6, flexShrink: 0}}/>
                            <Typography
                                noWrap
                                sx={{
                                    fontSize: ultimo ? 13 : 12,
                                    fontWeight: ultimo ? 700 : 400,
                                    opacity: ultimo ? 1 : 0.75,
                                    color: "#fff"
                                }}
                            >
                                {nombre}
                            </Typography>
                        </React.Fragment>
                    );
                })}
            </Box>

            {/* 🔹 Empresa y fecha */}
            <Box display={{xs: "none", lg: "flex"}} alignItems="center" gap={2} sx={{flexShrink: 0, opacity: 0.9}}>
                <Box display="flex" alignItems="center" gap={0.5} title="Empresa">
                    <BusinessRoundedIcon sx={{fontSize: 14}}/>
                    <Typography sx={{fontSize: 11, color: "#fff"}}>{razonSocial}</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={0.5} title="Fecha">
                    <EventRoundedIcon sx={{fontSize: 14}}/>
                    <Typography sx={{fontSize: 11, color: "#fff"}}>{fechaCompleta(new Date())}</Typography>
                </Box>
            </Box>

            {/* 🔹 Usuario */}
            <Box display="flex" alignItems="center" gap={1} sx={{flexShrink: 0}} title="Usuario">
                <Avatar sx={{width: 22, height: 22, fontSize: 11, bgcolor: "#26c6da", color: "#fff"}}>
                    {(name || "?").trim().charAt(0).toUpperCase()}
                </Avatar>
                <Typography sx={{fontSize: 12, fontWeight: 600, color: "#fff", display: {xs: "none", md: "block"}}}>
                    {name}
                </Typography>
            </Box>

            {/* 🔹 Sección derecha */}
            <Box display="flex" alignItems="center" gap={0.5}>
                <ThemeToggleButton/>

                <Button
                    color="transparent"
                    simple
                    aria-label="Dashboard"
                    justIcon
                    className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
                    muiClasses={{
                        label: rtlActive ? classes.labelRTL : "",
                    }}
                    onClick={() => history.push("/admin/dashboard")}
                >
                    <Dashboard
                        className={
                            classes.headerLinksSvg +
                            " " +
                            (rtlActive ? classes.links + " " + classes.linksRTL : classes.links)
                        }
                    />
                    <Hidden mdUp implementation="css">
                      <span className={classes.linkText}>
                        {rtlActive ? "لوحة القيادة" : "Dashboard"}
                      </span>
                    </Hidden>
                </Button>

                <div className={managerClasses}>
                    <Button
                        color="transparent"
                        aria-label="Person"
                        justIcon
                        aria-owns={openProfile ? "profile-menu-list" : null}
                        aria-haspopup="true"
                        onClick={handleClickProfile}
                        className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
                        muiClasses={{
                            label: rtlActive ? classes.labelRTL : "",
                        }}
                    >
                        <Person
                            className={
                                classes.headerLinksSvg +
                                " " +
                                (rtlActive ? classes.links + " " + classes.linksRTL : classes.links)
                            }
                        />
                        <Hidden mdUp implementation="css">
                            <span onClick={handleClickProfile} className={classes.linkText}>
                              {rtlActive ? "الملف الشخصي" : "Perfil"}
                            </span>
                        </Hidden>
                    </Button>

                    <Popper
                        open={Boolean(openProfile)}
                        anchorEl={openProfile}
                        transition
                        disablePortal
                        placement="bottom"
                        className={classNames({
                            [classes.popperClose]: !openProfile,
                            [classes.popperResponsive]: true,
                            [classes.popperNav]: true,
                        })}
                    >
                        {({TransitionProps}) => (
                            <Grow
                                {...TransitionProps}
                                id="profile-menu-list"
                                style={{transformOrigin: "0 0 0"}}
                            >
                                <Paper className={classes.dropdown}>
                                    <ClickAwayListener onClickAway={handleCloseProfile}>
                                        <MenuList role="menu">
                                                    <MenuItem
                                                        component={RouterLink}
                                                        to="/admin/user-page"
                                                        onClick={() => setOpenProfile(null)}
                                                        className={dropdownItem}
                                                    >
                                                        {rtlActive ? "الملف الشخصي" : "Perfil"}
                                                    </MenuItem>
                                            <Divider light/>
                                            <MenuItem
                                                onClick={handleCloseSession}
                                                className={dropdownItem}
                                            >
                                                {rtlActive ? "الخروج" : "Cerrar Sesión"}
                                            </MenuItem>
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </div>
            </Box>
        </Box>
    );
}
AdminNavbarLinks.propTypes = {
    ruta: PropTypes.arrayOf(PropTypes.string)
};
